import React, {useMemo} from 'react';
import {IValidationErrorObject} from '../../../../../incase-domain/common/validationErrorResponse';
import {IElementQuestionAnswer, IElementQuestionnaireWithAnswers} from '../../../../../incase-domain/elements/base/questionElementBase';
import {IElementPhotoAnswerType} from '../../../../../incase-domain/elements/question/photoAnswerQuestion';
import {generateErrorMessages, getErrorClasses} from '../../../../../utils/validation';
import AnswerRules from './actions/AnswerRules';
import ChangeComment from './actions/ChangeComment';
import ChangePhotoAnswer from './actions/ChangePhotoAnswer';
import RemoveAnswer from './actions/RemoveAnswer';

interface AnswerActionsProps {
    index: number;
    validationErrors: IValidationErrorObject | null;
    highlightedElement: IElementQuestionnaireWithAnswers;
    highlightedElementChangeHandler: {single: (field: keyof IElementQuestionnaireWithAnswers | string, value: unknown) => void};
    actions: AnswerActionType[];
    removeAnswer?: (index: number) => void;
    codebookAnswer?: IElementQuestionAnswer;
}

export enum AnswerActionType {
    CHANGE_COMMENT = 'CHANGE_COMMENT',
    REMOVE_ANSWER = 'REMOVE_ANSWER',
    ANSWER_RULES = 'ANSWER_RULES',
    CHANGE_PHOTO_ANSWER = 'CHANGE_PHOTO_ANSWER',
}

function AnswerActions(props: AnswerActionsProps): JSX.Element {
    const {index, validationErrors, highlightedElement, highlightedElementChangeHandler, actions, removeAnswer, codebookAnswer} = props;

    const validation = useMemo(
        () => ({
            errorComment: generateErrorMessages(validationErrors, `answers.${index}.comment`),
        }),
        [index, validationErrors]
    );

    return (
        <>
            <div className="u-flex u-h-center u-h-between">
                <div className="c-newAnswer__iconContainer">
                    {actions.includes(AnswerActionType.CHANGE_PHOTO_ANSWER) && (
                        <ChangePhotoAnswer
                            index={index}
                            imgSrc={(highlightedElement.answers[index] as IElementPhotoAnswerType).imgSrc}
                            highlightedElementChangeHandler={highlightedElementChangeHandler}
                            highlightedElement={highlightedElement}
                        />
                    )}
                    {actions.includes(AnswerActionType.CHANGE_COMMENT) && (
                        <ChangeComment
                            index={index}
                            highlightedElement={highlightedElement}
                            highlightedElementChangeHandler={highlightedElementChangeHandler}
                            codebookAnswer={codebookAnswer}
                        />
                    )}
                    {actions.includes(AnswerActionType.ANSWER_RULES) && (
                        <AnswerRules index={index} highlightedElement={highlightedElement} codebookAnswer={codebookAnswer} />
                    )}
                    {removeAnswer && actions.includes(AnswerActionType.REMOVE_ANSWER) && (
                        <RemoveAnswer index={index} highlightedElement={highlightedElement} removeAnswer={removeAnswer} />
                    )}
                </div>
            </div>
            <div className={`${validation ? `l-group__item ${getErrorClasses(validationErrors, `answers.${index}`)} answer-error` : ''}`}>
                {validation.errorComment}
            </div>
        </>
    );
}

export default AnswerActions;
